/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation, useReactiveVar } from '@apollo/client';
import { CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC031 } from 'Apollo/Mutations/Rules/FFIEC031';
import { tenantIdVar } from 'Apollo/config';
import ClassifyResultModal from '../../common/ClassifyResultModal';

const FFIEC031ClassifyResult = ({
    setShowClassifyResult, refetch, refetchTestData,
}) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [comment, setComment] = useState('');
    const [radio, setRadio] = useState('MARK_AS_REVIEW_REQUIRED');
    const [showLoader, setShowLoader] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo mutation to update the comment */
    const [createClassifyAuditLogForFFIEC031] = useMutation(
        CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC031,
        {
            variables: {
                input: {
                    comment,
                    batchId: Number(batchId),
                    eventName: radio,
                    ruleId: Number(ruleId),
                    tenantId: Number(tenantId),
                },
            },
        },
    );

    /* Calls createClassifyAuditLogForFFIEC031(), refetches the failed test and audit logs data  */
    const onClickFFIEC031Classify = async () => {
        setShowLoader(true);
        await createClassifyAuditLogForFFIEC031();
        setComment('');
        setShowLoader(false);
        refetch();
        refetchTestData();
        setShowClassifyResult(false);
    };

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <ClassifyResultModal
            onClickClassify={onClickFFIEC031Classify}
            showLoader={showLoader}
            comment={comment}
            setComment={setComment}
            radio={radio}
            setRadio={setRadio}
            setShowClassifyResult={setShowClassifyResult}
        />
    );
};

export default FFIEC031ClassifyResult;
